import { render, staticRenderFns } from "./LinkUser.vue?vue&type=template&id=f4b18e08&scoped=true"
import script from "./LinkUser.vue?vue&type=script&lang=js"
export * from "./LinkUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b18e08",
  null
  
)

export default component.exports